import { withStyles } from "@material-ui/core";
import React from "react";

import ProspectBulkUpload from "./prospectbulkUpload/ProspectBulkUpload";
import CampaignBulkUpload from "./campaignbulkUpload/CampaignBulkUpload";

import { Styles } from "../../assests/styles/DashboradStyles";

const BulkUpload = (props) => {
  return (
    <React.Fragment>
      <div
       //style={{ marginTop: "1rem", marginLeft: "1rem" }}
       >
        {props?.bulkUploadProspect === true && <ProspectBulkUpload handleSnackbar={props.handleSnackbar}/>}
        {props?.bulkUploadCampaign === true && <CampaignBulkUpload />}
      </div>
    </React.Fragment>
  );
};

export default withStyles(Styles)(BulkUpload);
